import { currentPage, initNewSection } from '../common/layout';
import { getMakeModelFilter } from '../common/make-model-filter-loader';
import { banners, commentsCountUpdate, hitPageView } from '../common/utils/fn';
import '../common/jquery-snap-scroll';
import { getM1FindVehicleEu, getM1FindVehicleUs } from '../common/shop/m1-find-vehicle-widget-loader';
import { getLoadMoreContent } from '../common/utils/load-more-btn-new.-loader';

currentPage.pageInit = ($page, pageData, pageId) => {
  commentsCountUpdate();

  $('.msnt-items-slider').snapScrollControl();
  
  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });

  getMakeModelFilter().then((api) => {
    api.makeModelFilter();
  });
  getM1FindVehicleEu().then((api) => {
    api.m1FindVehicleEu();
  });
  getM1FindVehicleUs().then((api) => {
    api.m1FindVehicleUs();
  });
};

currentPage.pageLoadMore = ($html, $btnBox) => {
  //$btnBox.replaceWith($html);
  initNewSection($html);
  
  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });

  // hybridLazyLoad();
  // bannerLazyload();
  commentsCountUpdate();
  // banners($html);
  hitPageView(document.location.pathname);
};
